import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const DEFAULT_OG = "https://highwayslens.co.uk/og-image.jpg";
const CANONICAL_BASE = "https://highwayslens.co.uk";

export default function Seo({ title, description, image, path, jsonLd }) {
  const fullTitle = title
    ? /highways\s?lens/i.test(title)
      ? title
      : `${title} · HighwaysLens`
    : "Highways Lens | Highways Photography, Drone & Video";
  const desc =
    description ||
    "HighwaysLens captures the people, projects, plant, places, and progress behind the UK highways sector, photography, drone and video.";
  const ogImage = image || DEFAULT_OG;
  const url =
    CANONICAL_BASE +
    (path || (typeof window !== "undefined" ? window.location.pathname : ""));

  useEffect(() => {
    if (!jsonLd) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-seo-jsonld", "true");
    el.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(el);
    return () => {
      document.head.removeChild(el);
    };
  }, [jsonLd]);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="HighwaysLens" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
